var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alert Octagon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Glyph",
    d: "M13.4517 1.66669H6.54818L1.66663 6.54824V13.4518L6.54818 18.3334H13.4517L18.3333 13.4518V6.54824L13.4517 1.66669ZM10.0001 5.65001C10.4168 5.65001 10.6668 5.98335 10.6668 6.31668V10.4833C10.6668 10.9 10.3335 11.15 10.0001 11.15C9.58347 11.15 9.33347 10.9 9.33347 10.4833V6.31668C9.33347 5.90001 9.6668 5.65001 10.0001 5.65001ZM11.0833 13.2751C11.0833 13.8734 10.5983 14.3584 9.99997 14.3584C9.40166 14.3584 8.91664 13.8734 8.91664 13.2751C8.91664 12.6768 9.40166 12.1918 9.99997 12.1918C10.5983 12.1918 11.0833 12.6768 11.0833 13.2751Z",
    fill: "#D21C1C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.265cbbf7819efa638bdcdab122fc495f.svg";
export { ForwardRef as ReactComponent };